import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfDialog({ open, onOk, onCancel, onClose, children, disabled }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ whiteSpace: 'pre-line' }}>
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onCancel && (
          <Button onClick={onCancel} disabled={disabled}>
            キャンセル
          </Button>
        )}
        <Button onClick={onOk} disabled={disabled}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfDialog.defaultProps = {
  disabled: false
};
